import { w as y, T as v, h, E as d, c } from "./emotion-element-f0de968e.browser.esm.js";
import { C as k } from "./emotion-element-f0de968e.browser.esm.js";
import * as u from "react";
import { insertStyles as p } from "../../utils/dist/emotion-utils.browser.esm.js";
import { useInsertionEffectWithLayoutFallback as f } from "../../use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js";
import { serializeStyles as g } from "../../serialize/dist/emotion-serialize.esm.js";
import "../../../../_virtual/hoist-non-react-statics.cjs.js";
var m = function(e, r) {
  var s = arguments;
  if (r == null || !h.call(r, "css"))
    return u.createElement.apply(void 0, s);
  var o = s.length, n = new Array(o);
  n[0] = d, n[1] = c(e, r);
  for (var t = 2; t < o; t++)
    n[t] = s[t];
  return u.createElement.apply(null, n);
};
(function(a) {
  var e;
  e || (e = a.JSX || (a.JSX = {}));
})(m || (m = {}));
var A = /* @__PURE__ */ y(function(a, e) {
  var r = a.styles, s = g([r], void 0, u.useContext(v)), o = u.useRef();
  return f(function() {
    var n = e.key + "-global", t = new e.sheet.constructor({
      key: n,
      nonce: e.sheet.nonce,
      container: e.sheet.container,
      speedy: e.sheet.isSpeedy
    }), l = !1, i = document.querySelector('style[data-emotion="' + n + " " + s.name + '"]');
    return e.sheet.tags.length && (t.before = e.sheet.tags[0]), i !== null && (l = !0, i.setAttribute("data-emotion", n), t.hydrate([i])), o.current = [t, l], function() {
      t.flush();
    };
  }, [e]), f(function() {
    var n = o.current, t = n[0], l = n[1];
    if (l) {
      n[1] = !1;
      return;
    }
    if (s.next !== void 0 && p(e, s.next, !0), t.tags.length) {
      var i = t.tags[t.tags.length - 1].nextElementSibling;
      t.before = i, t.flush();
    }
    e.insert("", s, t, !1);
  }, [e, s.name]), null;
});
function E() {
  for (var a = arguments.length, e = new Array(a), r = 0; r < a; r++)
    e[r] = arguments[r];
  return g(e);
}
function J() {
  var a = E.apply(void 0, arguments), e = "animation-" + a.name;
  return {
    name: e,
    styles: "@keyframes " + e + "{" + a.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
export {
  k as CacheProvider,
  A as Global,
  v as ThemeContext,
  m as createElement,
  E as css,
  m as jsx,
  J as keyframes,
  y as withEmotionCache
};
